/**
 * Bundle Modal Component
 * Uses theme's modal-element system for consistency
 */

class BundleModal {
  constructor(config) {
    this.id = config.id;
    this.title = config.title;
    this.content = config.content;
    this.style = config.style || 'bottom-sheet';
    this.onDismiss = config.onDismiss || null;
  }

  /**
   * Render modal HTML using theme's modal-element component
   * @returns {string} HTML string
   */
  render() {
    return `
      <modal-element id="${this.id}" class="modal invisible absolute bottom-0 left-0 w-full h-full" role="dialog" hidden style="z-index: 9999;">
        <overlay-element class="fixed-modal opacity-0 z-1 absolute top-0 left-0 w-full h-full" aria-controls="${this.id}" aria-expanded="false" style="z-index: 9998;"></overlay-element>
        <div class="modal__container flex flex-col z-3 absolute left-0 bottom-0 w-full" style="z-index: 9999;">
          <div class="modal__header flex items-center justify-between relative">
            <span class="font-medium text-sm md:text-base">${this.title}</span>
            <button class="close flex items-center justify-center absolute top-0 right-0" type="button" is="magnet-button" aria-controls="${this.id}" aria-expanded="false" aria-label="Close">
              <svg class="icon icon-close icon-sm" viewBox="0 0 20 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15L15 5M5 5L15 15"></path>
              </svg>
            </button>
          </div>
          <div class="modal__content flex flex-col overflow-hidden">
            <div class="modal__scrollable grid gap-4" style="display: block !important; grid-template-columns: unset !important;">
              ${this.content}
            </div>
          </div>
        </div>
      </modal-element>
    `;
  }

  /**
   * Show modal using theme's modal-element
   */
  static async show(modalId) {
    // Wait for the modal-element custom element to be defined
    await customElements.whenDefined('modal-element');

    const modal = document.getElementById(modalId);
    if (!modal) {
      console.error('[BundleModal] Modal not found with ID:', modalId);
      return;
    }

    // Call the modal element's show() method - theme handles all visibility
    if (typeof modal.show === 'function') {
      modal.show();
    } else {
      // Fallback to setting attribute directly
      modal.setAttribute('open', '');
    }
  }

  /**
   * Hide modal using theme's modal-element
   */
  static hide(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      // Call the modal element's hide() method - theme handles all visibility
      if (typeof modal.hide === 'function') {
        modal.hide();
      } else {
        // Fallback to removing attribute
        modal.removeAttribute('open');
      }
    }
  }

  /**
   * Create section with icon
   */
  static createSection(title, content, icon = null) {
    return `
      <div class="bundle-modal-section">
        ${icon ? `<div class="bundle-modal-section__icon">${icon}</div>` : ''}
        <div class="bundle-modal-section__content">
          <h3 class="bundle-modal-section__title">${title}</h3>
          <p class="bundle-modal-section__text">${content}</p>
        </div>
      </div>
    `;
  }

  /**
   * Create bullet list
   */
  static createBulletList(items) {
    return `
      <ul class="bundle-modal-list">
        ${items.map(item => `<li class="bundle-modal-list__item">${item}</li>`).join('')}
      </ul>
    `;
  }
}

// Export to global scope
window.BundleModal = BundleModal;
